module.exports = __webpack_public_path__ + "8f818cb8a793d0cf9a1bcbd7f5849abf.svg";